import OpenInNewOutlinedIcon from "@mui/icons-material/OpenInNewOutlined";
import { Box, Link, Typography } from "@mui/material";

type Props = { url: string; text: string; isFlexBasisDisabled?: boolean };

export const ExternalLink = ({ url, text, isFlexBasisDisabled }: Props) => (
  <Link
    href={url}
    target="_blank"
    mx={1}
    display="flex"
    alignItems="center"
    sx={{
      textDecoration: "none",
      "&:hover": {
        textDecoration: "underline",
      },
    }}
  >
    <Box display="flex" alignItems="center" gap={1}>
      <Typography flexBasis={isFlexBasisDisabled ? undefined : ["55%", "100%"]}>
        {text}
      </Typography>
      <OpenInNewOutlinedIcon sx={{ fontSize: "0.9rem" }} />
    </Box>
  </Link>
);
